import { render, staticRenderFns } from "./get.vue?vue&type=template&id=1113815c&"
import script from "./get.vue?vue&type=script&lang=js&"
export * from "./get.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1113815c')) {
      api.createRecord('1113815c', component.options)
    } else {
      api.reload('1113815c', component.options)
    }
    module.hot.accept("./get.vue?vue&type=template&id=1113815c&", function () {
      api.rerender('1113815c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/playground/page-argu/get.vue"
export default component.exports